import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../lib/utils';

interface NavLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  active: boolean;
  badge?: number;
  dataTour?: string;
}

export function NavLink({ to, icon, label, active, badge, dataTour }: NavLinkProps) {
  return (
    <Link
      to={to}
      data-tour={dataTour}
      className={cn(
        "flex flex-col items-center justify-center py-2 px-2 transition-colors duration-200 rounded-lg",
        active
          ? "text-primary-brown"
          : "text-gray-400 hover:text-text-secondary"
      )}
    >
      <span className="relative">
        {icon}
        {!!badge && (
          <span className="absolute -top-1 -right-1.5 min-w-[16px] h-4 px-[3px] flex items-center justify-center rounded-full bg-primary-brown text-white text-[10px] font-semibold leading-none">
            {badge > 99 ? '99+' : badge}
          </span>
        )}
      </span>
      {active && <span className="text-xs mt-1 font-medium text-center">{label}</span>}
    </Link>
  );
}
